module.exports = __webpack_public_path__ + "img/slc.74fdd7c6.jpg";